import { Card, Box, Typography } from "@mui/material";
import { SvgIconComponent } from "@mui/icons-material";
import { ReactNode } from "react";

type DashboardStatsItemProps = {
  title: string;
  description: ReactNode;
  detail?: ReactNode;
  icon: SvgIconComponent;
};
export default function DashboardStatsItem({
  title,
  description,
  detail,
  icon: Icon,
}: DashboardStatsItemProps) {
  return (
    <Card sx={{ py: 2.5, px: 3, width: 1, boxSizing: "border-box" }}>
      <Box display="flex" alignItems="center" gap={1.25}>
        <Box
          sx={{
            width: 34,
            height: 34,
            borderRadius: "9px",
            backgroundColor: "rgba(27, 75, 127, 0.1)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <Icon sx={{ color: "#1B4B7F", fontSize: 20 }} />
        </Box>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ fontWeight: 600 }}
        >
          {title}
        </Typography>
      </Box>
      <Typography sx={{ py: 1, fontSize: 26, fontWeight: 700 }}>
        {description}
      </Typography>
      {detail ? (
        <Typography variant="body2" color="text.secondary">
          {detail}
        </Typography>
      ) : null}
    </Card>
  );
}
